import { Divider, Flex, Icon, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ExchangeRate } from './elements/ExchangeRate'
import * as Styled from './styles'

interface InvoiceSummaryExchangeRateProps {
  amountInBaseCurrency: string
}

export const InvoiceSummaryExchangeRate = ({ amountInBaseCurrency }: InvoiceSummaryExchangeRateProps): ReactElement => {
  const [isExchangeRateVisible, setIsExchangeRateVisible] = useState(false)
  const { t } = useTranslation()

  const handleExchangeRateToggleClick = useCallback(() => {
    setIsExchangeRateVisible(!isExchangeRateVisible)
  }, [isExchangeRateVisible])

  const handleExchangeRateClose = useCallback(() => {
    setIsExchangeRateVisible(false)
  }, [])

  return (
    <Styled.ExchangeRateWrapper>
      <Styled.ExchangeRateInfoWrapper onClick={handleExchangeRateToggleClick}>
        <Flex justifyContent="space-between">
          <Text colorVariant="secondary" variant="bodySM">
            {t('external_invoices.editor.form.field.invoice_lines.exchange_rate.expected_amount.label')}
          </Text>
          <Flex>
            <Text colorVariant="secondary" nowrap variant="bodySM">
              {amountInBaseCurrency}
            </Text>
            <Space horizontal size="s8" />
            <Icon icon={isExchangeRateVisible ? 'chevronUp' : 'chevronDown'} />
          </Flex>
        </Flex>
      </Styled.ExchangeRateInfoWrapper>
      {isExchangeRateVisible && (
        <>
          <Space size="s8" />
          <Divider />
          <Space size="s8" />
          <ExchangeRate onSave={handleExchangeRateClose} />
        </>
      )}
    </Styled.ExchangeRateWrapper>
  )
}
